<template>
  <div class="footer">
    <div class="footer-content flex-row justify-between align-center">
      <div class="copyright">
        <span>© 2025 Debris - all rights reserved</span>
      </div>
      <div class="social-media flex-row">
        <div class="social-item" @click="goXiaohongshu" title="小红书">
          <svg-icon
            class="svg xiaohongshu-svg"
            iconClass="xiaohongshu"
          ></svg-icon>
        </div>
        <div class="social-item" @click="goWeibo" title="微博">
          <svg-icon
            class="svg weibo-svg"
            iconClass="weibo"
          ></svg-icon>
        </div>
        <div class="social-item" @click="goBilibili" title="B站">
          <svg-icon
            class="svg bilibili-svg"
            iconClass="bilibili"
          ></svg-icon>
        </div>
        <div class="social-item" @click="goInstagram" title="INS">
          <svg-icon
            class="svg instagram-svg"
            iconClass="instagram"
          ></svg-icon>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {

    }
  },
  created() { },
  methods: {
    goXiaohongshu() {
      window.open('https://www.xiaohongshu.com/user/profile/656577ef000000003c00ddae?xsec_token=YB7UtfsVcGD1Q0y-lNtHOOjN94Rdrn4_Dl6m6vLSCKy5A%3D&xsec_source=app_share&xhsshare=&shareRedId=ODs4NTo8SU82NzUyOTgwNjlGOTdISUdO&apptime=1767064943&share_id=cbd922499ed946b2a2a91d39e353ae89&share_channel=copy_link', '_blank');
    },
    goWeibo() {
      window.open('https://weibo.com/u/5940017159', '_blank');
    },
    goBilibili() {
      window.open('https://b23.tv/vlmhAqy', '_blank');
    },
    goInstagram() {
      window.open('https://www.instagram.com/debris.animation/', '_blank');
    }
  },

}
</script>

<style lang="scss">
.footer {
  z-index: 999;
  width: 100%;
  height: calc((100vh - 8.16rem)/2);
  min-height: 0.5rem;
  background-color: #262626;

  .footer-content {
    width: 100%;
    height: 100%;
    padding: 0 0.24rem;

    .copyright {
      span {
        color: rgba(255, 255, 255, 0.3);
        font-size: 0.14rem;
        font-family: "Poppins";
        font-weight: 500;
      }
    }

    .social-media {
      gap: 0.16rem;

      .social-item {
        .svg {
          color: rgba(255, 255, 255, 0.3);
          transition: color 0.2s;
          cursor: pointer;
        }
        .xiaohongshu-svg {
          width: 0.36rem;
          height: 0.24rem;
        }
        .weibo-svg {
          width: 0.24rem;
          height: 0.24rem;
        }
        .bilibili-svg {
          width: 0.36rem;
          height: 0.24rem;
        }
        .instagram-svg {
          width: 0.24rem;
          height: 0.24rem;
        }
        &:hover {
          .svg {
            color: rgba(255, 255, 255, 1);
          }
        }
      }
    }
  }
}
</style>
